<div class="responsive-card">
  <div class="d-flex flex-column gap-4">
    <div class="d-flex flex-column gap-3">
      <div class="responsive-card-title" i18n>Withdrawal Instructions</div>
      <div class="responsive-card-description mb-2" i18n>
        Specify how much to withdraw from each fund to make the payments. If one fund depletes its balance, the
        withdrawal instructions will convert entirely to the other fund.
      </div>
    </div>
    <ng-container *ngIf="!(isLoading$ | async); else loading">
      <ng-container *ngIf="!!formGroup">
        <div class="percentage-input-container" [formGroup]="formGroup">
          <ng-container formArrayName="instructions">
            <ng-container *ngFor="let allocation of formGroup.controls.instructions.controls" [formGroup]="allocation">
              <app-vb-withdrawal-percent-field
                formControlName="percentage"
                [fundType]="allocation.controls.fund.getRawValue() | fundTypeById : (fundTypes$ | async)"
                [balance]="allocation.controls.balance?.getRawValue()" />
            </ng-container>
          </ng-container>
        </div>
        <hr class="no-margin" />
        <div class="d-flex justify-content-between">
          <div class="total-label" i18n>Total</div>
          <div class="total-amount" [class.red-text]="formGroup.controls.instructions?.invalid && formSubmitted">
            {{ percentageTotal }}%
          </div>
        </div>
        <div *ngIf="formGroup.controls.instructions?.invalid && formSubmitted" class="form-error">
          <img src="assets/icons/dark/Circle-Error.svg" alt="Error" i18n-alt />
          {{ errorText }}
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #loading>
  <div class="d-flex flex-column gap-4">
    <div *appRepeat="2" class="d-flex justify-content-between">
      <div class="d-flex flex-column gap-2">
        <div class="d-flex gap-1">
          <lib-loading-shimmer shape="circle" [height]="'0.75rem'" [width]="'0.75rem'" />
          <lib-loading-shimmer [height]="'1.5rem'" [width]="'4rem'" />
        </div>
        <lib-loading-shimmer [height]="'1rem'" [width]="'10rem'" />
      </div>
      <div>
        <lib-loading-shimmer [height]="'3.5rem'" [width]="'12rem'" />
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between pb-3">
    <lib-loading-shimmer [height]="'1rem'" [width]="'4rem'" />
    <lib-loading-shimmer [height]="'1rem'" [width]="'3rem'" />
  </div>
</ng-template>
